import { useEffect, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface DsModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  footer?: ReactNode;
  /** `large` = 880px, `wide` = 1180px; both stay within 90vw. Default 580px. */
  size?: 'default' | 'large' | 'wide';
  children: ReactNode;
}

export function DsModal({ open, onClose, title, description, footer, size = 'default', children }: DsModalProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  const target = document.querySelector('[data-ds="eos"]') ?? document.getElementById('root')!;

  return createPortal(
    <div className="ds-modal-backdrop" onClick={onClose}>
      <div className={`ds-modal${size === 'default' ? '' : ` ${size}`}`} onClick={(e) => e.stopPropagation()}>
        <div className="ds-modal-header">
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
        <div className="ds-modal-body">{children}</div>
        {footer && <div className="ds-modal-footer">{footer}</div>}
      </div>
    </div>,
    target,
  );
}
